import { Box, Tooltip, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import downloadFill from "@iconify/icons-eva/download-fill";
import QRCode from "react-qr-code";
import {
  downloadQrFromContainer,
  toSafeId,
  AMIK_LOGO_URL,
} from "src/utils/downloadQr";

/**
 * List-cell action: when a payment gateway has a upi_url, renders a button to
 * download a QR code for that UPI URL. Renders "-" when no upi_url is set.
 */
export const UpiQrDownload = ({ upiUrl, rowId }) => {
  if (!upiUrl) return "-";

  const qrDomId = `pg-upi-qr-${toSafeId(rowId)}`;

  return (
    <>
      <Tooltip title="Download UPI QR">
        <IconButton
          size="small"
          color="primary"
          onClick={(e) => {
            // Prevent the row-click navigation to the detail page.
            e.stopPropagation();
            downloadQrFromContainer(qrDomId, `UPI_${toSafeId(rowId)}`, {
              logoUrl: AMIK_LOGO_URL,
            });
          }}
        >
          <Icon icon={downloadFill} width={18} height={18} />
        </IconButton>
      </Tooltip>

      {/* Hidden QR used only as the source for the downloaded image. */}
      <Box
        id={qrDomId}
        sx={{ position: "absolute", left: -9999, top: -9999 }}
        aria-hidden
      >
        <QRCode value={upiUrl} size={256} />
      </Box>
    </>
  );
};

export default UpiQrDownload;
